export default __webpack_public_path__ + "static/media/02.c808ec85.jpg";